import { notification } from 'antd'
import axios from 'axios'

// const qs = require('querystring')

const apiRoot = process.env.REACT_APP_API_URL

const fsConfig = {
  root: apiRoot,
  getMenu: '/permissions/menuItems',
}

/* const oldLeftMenuData = [
  {
    title: 'Settings',
    key: 'settings',
    icon: 'icmn icmn-cog utils__spin-delayed--pseudo-selector',
  },
  {
    divider: true,
  },
  {
    title: 'Dashboard',
    key: 'dashboardAlpha',
    url: '/dashboard/alpha',
    icon: 'icmn icmn-database',
  },
  {
    title: 'Update Tags',
    key: 'pricingTable',
    url: '/subscription/pricing',
    icon: 'icmn icmn-pencil',
  },
  {
    title: 'User Profile',
    key: 'userProfile',
    url: '/profile',
    icon: 'icmn icmn-user',
  },
]; */

export async function getMenuData(token) {
  const url = fsConfig.root + fsConfig.getMenu
  const newConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      pragma: 'no-cache',
      Authorization: `Bearer ${token}`,
    },
  }
  return axios
    .get(url, newConfig)
    .then(response => {
      return response.data
    })
    .catch(error => {
      notification.warning({
        message: 'Error obteniendo datos de menú',
        description: error.message,
      })
      return null
    })
}

export async function getLeftMenuData(token) {
  return getMenuData(token)
}

export async function getTopMenuData(token) {
  return getMenuData(token)
  /*   const data = getMenuData(token)
  if ( data ) {
    const result = data.filter(el => !el.divider);
    return result;
  }
  return data; */
}
